import Card from './Card';
import Progress from './Progress';

// ----------------------------------------------------------------------

export default function ComponentsOverrides(theme) {
  return Object.assign(
    Card(theme),
    // Progress(theme)
  );
}
